import { IKeytipProps } from "@fluentui/react/lib/Keytip";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

export const getTopLevelKeytipProps = memoizeFunction(
  (topLevelKeytip: string): IKeytipProps => {
    const keytipSequence = topLevelKeytip.toLocaleLowerCase();
    return {
      content: topLevelKeytip,
      keySequences: [keytipSequence],
      hasMenu: true,
    };
  }
);
